<ng-container *ngIf="showIcon">
  <div class="listbox-empty-icon">
    <ng-content select="[icon]" />
  </div>
</ng-container>

<div class="font-size-16">
  <ng-content select="[text]" />
</div>
